import {
  CONNECT_AS_CLIENT,
  LOGOUT_AS_CLIENT,
  LOGIN_SUCCESS
} from '../constants/auth';
import history from '../history';
import Cookies from 'js-cookie';

const COOKIE_KEY = 'wineservices:connectClient';

export const getAuthTokenAsClient = () => {
  let authtoken = Cookies.get(COOKIE_KEY);
  if (authtoken) {
    authtoken = authtoken.replace(/"/g, '');
    setAuthTokenAsClient(authtoken);
    return authtoken;
  } else {
    return null;
  }
};

export const setAuthTokenAsClient = (data) => {
  Cookies.set(COOKIE_KEY, JSON.stringify(data));

  let oldAuthtoken = localStorage.getItem(COOKIE_KEY);
  if (oldAuthtoken) {
    localStorage.removeItem(COOKIE_KEY);
  }
};

export const destroyAuthTokenAsClient = () => {
  Cookies.remove(COOKIE_KEY);
};

export const logAsClient = (clientToken) => async (dispatch) => {
  if (clientToken) {
    destroyAuthTokenAsClient();
    await setAuthTokenAsClient(clientToken);

    dispatch({
      type: CONNECT_AS_CLIENT,
      payload: clientToken
    });

    if (
      window.location.pathname === '/' ||
      window.location.pathname.startsWith('/connect') ||
      !getAuthTokenAsClient()
    ) {
      history.push('/dashboard');
    }
  }
};

export const logoutAsClient = () => async (dispatch) => {
  destroyAuthTokenAsClient();
  dispatch({ type: LOGOUT_AS_CLIENT });
  window.location.reload();
};
